import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useAppSelector } from "Redux/hooks";
import { selectStyle } from "Redux/appSlice";

type Props = {
  sizeOf?: string;
  color?: string;
  onClick: () => void;
};
/*
  @function ExitButton
  render exit button that can be clicked
  @param onClick {function} - called function on click
  @returns {React.Node}
*/
export default function ExitButton({ sizeOf, color, onClick }: Props) {
  const [hovered, setHovered] = useState(false);
  const { color2 } = useAppSelector(selectStyle);
  return (
    <button
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: (hovered ? color2 : "") }}
      className={`${
        sizeOf ? sizeOf : "w-6 h-6"
      } rounded-full flex justify-center items-center text-white bg-black transition-colors`}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faXmark} />
    </button>
  );
}
